export const categories = [
  {
    slug: 'shehui-guancha',
    name: '社会观察',
    description: '深入社会肌理，发掘被忽视的真实故事与结构性问题',
    icon: 'ri-eye-line',
    color: 'accent',
  },
  {
    slug: 'wenhua-yanjiu',
    name: '文化研究',
    description: '跨越东西方文化边界，解读符号、仪式与身份认同',
    icon: 'ri-book-open-line',
    color: 'primary',
  },
  {
    slug: 'keji-qianyan',
    name: '科技前沿',
    description: '追踪技术演进脉络，审视数字文明对人类社会的重塑',
    icon: 'ri-cpu-line',
    color: 'secondary',
  },
  {
    slug: 'lishi-tansuo',
    name: '历史探索',
    description: '重访历史现场，在时间长河中寻找理解当下的钥匙',
    icon: 'ri-compass-3-line',
    color: 'accent',
  },
  {
    slug: 'yishu-pinglun',
    name: '艺术评论',
    description: '以批判性视角审视当代艺术实践与美学话语体系',
    icon: 'ri-palette-line',
    color: 'primary',
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});